import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';
import { Search, RotateCcw, Download } from 'react-feather';
import colors from '../../../../theme/colors';

const FormActions = ({
  isFormSubmittable,
  isTableNotLoading,
  dataApi,
  handleReset,
  downloadExcel,
}) => (
  <>
    <button
      type="button"
      onClick={handleReset}
      disabled={!isTableNotLoading}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px',
        fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
        border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#6b7280',
        cursor: !isTableNotLoading ? 'not-allowed' : 'pointer',
        opacity: !isTableNotLoading ? 0.5 : 1, transition: 'all 0.15s',
      }}
    >
      <RotateCcw size={13} />
      Limpiar
    </button>
    <button
      type="submit"
      disabled={!isFormSubmittable || !isTableNotLoading}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
        fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px', border: 'none',
        backgroundColor: colors.primary, color: '#fff',
        cursor: (!isFormSubmittable || !isTableNotLoading) ? 'not-allowed' : 'pointer',
        opacity: (!isFormSubmittable || !isTableNotLoading) ? 0.5 : 1, transition: 'all 0.15s',
      }}
    >
      {!isTableNotLoading
        ? <Spinner style={{ height: '13px', width: '13px' }} />
        : <Search size={13} />}
      {!isTableNotLoading ? 'Buscando...' : 'Buscar'}
    </button>
    <button
      type="button"
      onClick={downloadExcel}
      disabled={dataApi === '' || !isTableNotLoading}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
        fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
        border: `1px solid ${colors.primary}`, backgroundColor: '#fff',
        color: colors.primary,
        cursor: (dataApi === '' || !isTableNotLoading) ? 'not-allowed' : 'pointer',
        opacity: (dataApi === '' || !isTableNotLoading) ? 0.5 : 1, transition: 'all 0.15s',
      }}
    >
      <Download size={13} />
      Excel
    </button>
  </>
);

FormActions.propTypes = {
  isFormSubmittable: PropTypes.bool,
  isTableNotLoading: PropTypes.bool,
  dataApi: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  handleReset: PropTypes.func.isRequired,
  downloadExcel: PropTypes.func.isRequired,
};

export default FormActions;
